import React from "react";
import { useParams } from "react-router-dom";
import { SeasonDivisionProvider } from "../context/season_division_context";
import { AdminListView } from "../components";
import styled from "styled-components";

const AdminClassification = () => {
  const { groupId } = useParams();
  return (
    <SeasonDivisionProvider>
      <Wrapper className="page section section-center">
        <AdminListView divisionId={groupId} />
      </Wrapper>
    </SeasonDivisionProvider>
  );
};

const Wrapper = styled.section``;

export default AdminClassification;
